// extracted by mini-css-extract-plugin
export var banner = "_gp-0";
export var closeButton = "_gp-2";
export var greenCheckmark = "_gp-3";
export var hereLink = "_gp-4";
export var titleIcon = "_gp-1";